import { render, staticRenderFns } from "./TabbedLink.vue?vue&type=template&id=4374092c&scoped=true&"
import script from "./TabbedLink.vue?vue&type=script&lang=js&"
export * from "./TabbedLink.vue?vue&type=script&lang=js&"
import style0 from "./TabbedLink.vue?vue&type=style&index=0&id=4374092c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4374092c",
  null
  
)

export default component.exports